import { render, staticRenderFns } from "./ShareMenu.vue?vue&type=template&id=8ca0946e&scoped=true"
import script from "./ShareMenu.vue?vue&type=script&lang=js"
export * from "./ShareMenu.vue?vue&type=script&lang=js"
import style0 from "./ShareMenu.vue?vue&type=style&index=0&id=8ca0946e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca0946e",
  null
  
)

export default component.exports